import script from "./UserOrdersList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOrdersList.vue?vue&type=script&setup=true&lang=js"

import "./UserOrdersList.vue?vue&type=style&index=0&id=51c373ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c373ae"]])

export default __exports__